// removed by extract-text-webpack-plugin
module.exports = {"xrColorPrimary":"#2362FB"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 232